import { AfterViewInit, ChangeDetectorRef, Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { CmsService } from '../../core/services/cms.service';
import { LogCategory, LoggerService, LogType, LogWidget } from '../../core/services/logger.service';
import { ProfileService } from '../../core/services/profile.service';
import { TagManagerService } from '../../core/services/tag-manager.service';
import { ProfileSetting } from '../../pages/profile/profile.component';
import { IWidgetComponent } from '../../shared/widget/i-widget-component';
import { Widget } from '../../shared/widget/widget';

@Component({
    selector: 'app-my-favorites',
    templateUrl: './my-favorites.component.html',
    styleUrls: ['./my-favorites.component.scss'],
    standalone: false
})
export class MyFavoritesComponent implements OnInit, OnDestroy, AfterViewInit, IWidgetComponent {
    public data: Widget;
    public isActive: boolean = false;
    public tags: string[] = [];
    filterText: '';
    public editStatus: boolean = false;

    @HostBinding('class')
    get size(): string {
        return 'col-md-' + this.data.Size.toString();
    }

    constructor(
        private logger: LoggerService,
        public cms: CmsService,
        private gtm: TagManagerService,
        private changeDetector: ChangeDetectorRef,
        public profileService: ProfileService
    ) {
        this.log("constructor", null, LogCategory.Constructor);
    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Widget, LogWidget.MyLinks, category);
    }

    ngOnInit() {
        this.log("ngOnInit", null, LogCategory.Init);

    }

    ngOnDestroy() {
        this.log("ngOnDestroy", "", LogCategory.Destroy);
    }

    ngAfterViewInit() {
        this.cms.contentTypesChanged$.next(['links', 'documents']);
        // See https://blog.angularindepth.com/everything-you-need-to-know-about-the-expressionchangedafterithasbeencheckederror-error-e3fd9ce7dbb4
        // Added after error handling template added to component.
        this.changeDetector.detectChanges();
    }

    public updateFavorite(favorites, item) {

        //  Update the local variable so we don't have to re-fetch the whole profile
        //  after updating.
        const index = favorites.indexOf(item.Id);
        if (index > -1)
            favorites.splice(index, 1);

        //recording Favorites removed to Google Analytics
        this.gtm.gaLinkFave(this.profileService.labelLookup[this.data.meta.Name], item.Title, false);

        var data: ProfileSetting[] = [new ProfileSetting()]
        data[0].Id = ".Myke.Favorites";
        data[0].Type = "text";
        data[0].Value = item.Id;
        this.profileService.updateSettings(data, false);
    }

    public toggleEdit() {
        this.editStatus = !this.editStatus;
    }
}

